<template>
  <div>
    <div class="title">
      <h3>用户状态变更&nbsp;&nbsp;<button @click="look_note">备注说明</button></h3>
      <div id="notice">
        <h5>说明:</h5>
        <span>略</span><br>
        <span></span><br>
      </div>
    </div>

    <div class="content_edit">
      <pre-button @button-event="select_method" :pre_control="'control_userflag'" />

    </div>

    <div class="content_edit">
      <div class="row">
        <label>姓名:</label><input type="text" class="long1" v-model="username" readonly="readonly" />
          <label>原状态:</label><input type="text" class="long1" v-model="old_name" readonly="readonly" />
          <label>新状态:</label><input type="text" class="long1" v-model="new_name" readonly="readonly" />
     </div>
      <div class="row">
        <label v-for="(item,index) in list_flag" :key="index">
          <el-radio v-model="radio" :label="item.id" v-on:change="sel_new">{{item.val}}</el-radio>
        </label>
      </div>
      <div class="row">
        <label class="label_top2">备注:</label>
        <el-input type="textarea" :autosize="{ minRows: 1, maxRows: 2}" class="long5" placeholder="录入备注" v-model="note">
        </el-input>
      </div>
    </div>



    <!-- 这里放相关内容-->
    <div class="mytable_left" v-loading="fullscreenLoading" element-loading-text="拼命加载中..."
      element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
      <table class="dataintable">
        <thead>
          <tr class="tab_header">
            <th>序号</th>
            <th class="long1">姓名</th>
          </tr>
        </thead>
        <tbody class="tab_body">
          <tr v-for="(item, index) in list_user" :key="index" @click="sel_row(item)">
            <td>{{ item.row_num }}</td>
            <td class="long1">{{ item.val }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="mytable_right">
      <pre-table ref="file_table" @tab-event="refresh_data" :api_url="load_url" :pre_post="load_json">
        <template slot="tab_title">
          <tr>
            <th>序号</th>
            <th class="long1">姓名</th>
            <th>原状态</th>
            <th>新状态</th>
            <th>说明</th>
            <th>修改人</th>
            <th class="long1">更新时间</th>
          </tr>
        </template>
        <template slot="tab_tr" slot-scope="user">
          <tr v-bind:id="'com' + user.item.row_num" @click="sel_row2(user.item)">
            <td>{{ user.item.row_num }}</td>
            <td class="left long1">{{ user.item.u_name }}</td>
            <td>{{ user.item.old_name }}</td>
            <td>{{ user.item.new_name }}</td>
            <td>{{ user.item.note }}</td>
            <td>{{ user.item.upd_name }}</td>
            <td class="long1">{{ user.item.sys_date }}</td>
          </tr>
        </template>
      </pre-table>
    </div>


  </div>
</template>

<script>
  /*
名称：最简单 弹窗版
日期：2020-11-06
作者：hj
目标：
只有弹窗

*/
  import api from '@/utils/type.js'

  import {
    Method_DataByPage,
    Method_CompanyAction,
    Method_EasySelect,
    Method_EasyUpdate
  } from '@/utils/loadhttpdata.js';

  export default {
    name: "pre_tan_user_flag",
    components: {
      "pre-button": () => import("../per_old/pre_btn_control.vue"),
      "pre-table": () => import("../per_old/pre_table_nokey.vue")

    },
    data() {
      return {
        fullscreenLoading: false,
        load_url: '',
        load_json: '',

        list_flag: [],
        list_chang: [],
        list_user: [],
        row_id: '',
        username: '',
        old_name: '',
        old_id: '',
        new_name: '',
        new_id: '',
        note: '',
        radio: '1'


      };
    },
    created: function() {
      this.load_data();
    },
    methods: {
      look_note: function() {
        //收缩区 收放设置
        this.show_note = this.show_note ? false : true;
        if (this.show_note) {
          $("#notice").slideDown("slow");
        } else {
          $("#notice").slideUp("slow");
        }
      },
      select_method: function(type) {
        console.log(type);
        switch (type) {
          case 'add':
            this.fun_add();
            break;
          case 'upd':
            if (Number(this.row_id) == 0) {
              this.$message.error('请先选择要编辑的数据!');
              return;
            }
            this.fun_upd();
            break;
          case 'del':
            if (Number(this.row_id) == 0) {
              this.$message.error('请先选择要编辑的数据!');
              return;
            }
            // 不能在方法里传  this.变量
            this.fun_del();
            break;
          case 'sel':
            this.refresh_data();
            break;
            // case 'sub':
            // if (Number(this.t_rowid) == 0) {
            //   this.$message.error('请先选择要编辑的数据!');
            //   return;
            // }
            //   this.fun_sub();
            //   break;
            // case 'exl':
            //   this.fun_exl();
            //   break;
          default:
            this.$message.error('错误:标识:' + type + ' 没有配置相应方法!');
            break;
        }
      },
      load_data: function() {
        this.load_user();
        this.load_userflag();
      },
      refresh_data: function() {

      },
      fun_upd: function() {
        // if (this.old_id == this.new_id) {
        //   this.$message({
        //     message: '状态没有变化无需修改!',
        //     type: 'warning'
        //   });
        //   return;
        // }


        this.fullscreenLoading = true;
        this.$post(
          api.http_method,
          Method_EasyUpdate('data_userflag', this.row_id, this.old_id, this.new_id, this.note)
        ).then(res => {
          res = JSON.parse(res);
          // console.log(res);
          res = res.data;
          this.fullscreenLoading = false;
          if (Number.parseInt(res.status) == 1) {

            this.load_userchang(); //刷新状态
            this.$message({
              message: res.msg,
              type: 'success'
            });
          } else {
            this.$message({
              message: res.msg,
              type: 'warning'
            });
          }
        });
      },
      load_user: async function() {
        this.list_user = [];

        this.fullscreenLoading = true;
        this.$post(
          api.http_method,
          Method_EasySelect('data_alluser')
        ).then(res => {
          res = JSON.parse(res);
          this.fullscreenLoading = false;
          if (Number.parseInt(res.data.status) == 1) {
            this.list_user = res.data.data;
          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning'
            });
          }
        });
      },
      load_userchang: function() {
        let r = (Math.random() + '').substring(0, 4)
        this.load_url = api.http_method;
        this.load_json = Method_EasySelect('data_userchange', this.row_id, r);
      },
      load_userflag: function() {
        this.list_flag = [];

        this.fullscreenLoading = true;
        this.$post(
          api.http_method,
          Method_EasySelect('data_class', 'yg')
        ).then(res => {
          this.fullscreenLoading = false;
          res = JSON.parse(res);
          this.fullscreenLoading = false;
          if (Number.parseInt(res.data.status) == 1) {
            this.list_flag = res.data.data;
          } else {
            this.$message({
              message: res.data.msg,
              type: 'warning'
            });
          }
        });
      },
      sel_row: function(item) {
        console.log(item);
        this.sel_clear();
        this.row_id = item.id;
        this.username = item.val;
        this.select_oldname(item.flag);
        this.load_userchang();
      },
      sel_row2: function(item) {
        this.old_name = item.old_name;
        this.new_name = item.new_name;
      },
      sel_clear: function() {
        this.row_id = 0;
        this.username = '';
        this.old_id = '0';
        this.old_name = '';
        this.new_id = '0';
        this.new_name = '';
      },
      select_oldname: function(val) {
        for (var i = 0; i < this.list_flag.length; i++) {
          if (this.list_flag[i].id == val) {
            this.old_name = this.list_flag[i].val;
            this.old_id = this.list_flag[i].id;
            break;
          }
        }
      },
      sel_new: function() {
        for (var i = 0; i < this.list_flag.length; i++) {
          if (this.list_flag[i].id == this.radio) {
            this.new_name = this.list_flag[i].val;
            this.new_id = this.list_flag[i].id;
            break;
          }
        }
      }


    }
  };
</script>


<style scoped>
  .myedit {
    width: 100%
  }

  .mytable_left {
    display: inline-block;
    vertical-align: top;
    width: 20%;

  }

  .mytable_right {
    display: inline-block;
    vertical-align: top;
    width: 75%;
  }
  
  .row{
    margin-bottom: 10px;
  }
</style>
